import { fmt } from '../../lib/formatters.js';

/** Compact readout of the last text response: model, tokens, cost, finish. */
export function MetricsBar({ lastUsage }) {
  if (!lastUsage) return null;
  return (
    <div className="border-t border-border pt-4">
      <p className="mb-2 text-xs font-semibold uppercase tracking-wider text-ink-muted">Ultima risposta</p>
      <dl className="grid grid-cols-2 gap-y-1 text-xs">
        <dt className="text-ink-muted">Modello</dt>
        <dd className="text-ink">{lastUsage.model || '-'}</dd>
        <dt className="text-ink-muted">Token</dt>
        <dd className="text-ink">{fmt.int((lastUsage.usage && (lastUsage.usage.totalTokens || lastUsage.usage.total_tokens)) || 0)}</dd>
        <dt className="text-ink-muted">Costo</dt>
        <dd className="text-ink">{fmt.usdFine(lastUsage.costUsd || 0)}</dd>
        <dt className="text-ink-muted">Finish</dt>
        <dd className="text-ink">{lastUsage.finishReason || '-'}</dd>
      </dl>
      {lastUsage.personality && (
        <p className="mt-2 text-xs text-ink-muted">
          Personalità: <span className="text-ink">{lastUsage.personality.name}</span>
        </p>
      )}
    </div>
  );
}
